import CloseIcon from '@mui/icons-material/Close';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { WsButton, WsColors, WsDialog, WsTypography, WsTypoVariants } from 'wisestep-base';

import useGetCandidateSummary from '../../../../../features/candidateLayout/hooks/useGetCandidateSummary';
import StarLoader from '../../../../../features/jobs/post/components/StarLoader';
interface CandidateSummaryDialogProps {
  handleClose: () => void;
  handleOnSave: (summary: string) => void;
  resumeLocation: string;
  jobDescription: string;
  existedSummary: string;
}

const CandidateSummaryDialog = ({
  resumeLocation,
  jobDescription,
  handleClose,
  handleOnSave,
  existedSummary,
}: CandidateSummaryDialogProps) => {
  const { loading, candidateSummary } = useGetCandidateSummary(
    resumeLocation,
    jobDescription,
    existedSummary
  );

  const handleSave = () => handleOnSave(candidateSummary);
  return (
    <WsDialog openDialog={true} onClose={handleClose} size="small">
      <DialogTitle>
        <Grid container direction="row" justifyContent="space-between">
          <Grid item>
            <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
              Generated Candidate Summary
            </WsTypography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleClose} sx={{ padding: 0 }}>
              <CloseIcon sx={{ fill: WsColors.GreyBlack, cursor: 'pointer' }} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      {loading ? (
        <Grid>
          <StarLoader />
        </Grid>
      ) : (
        <DialogContent dividers sx={{ px: 3 }}>
          <Grid container direction="column" rowSpacing={1}>
            <Grid item>
              <WsTypography variant={WsTypoVariants.TITLE}>Candidate Summary</WsTypography>
            </Grid>
            <Grid item>
              <Typography
                fontWeight={500}
                dangerouslySetInnerHTML={{
                  __html: candidateSummary ?? '',
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
      )}
      <DialogActions sx={{ p: 1 }}>
        <WsButton disabled={loading} onClick={handleSave}>
          Save
        </WsButton>
      </DialogActions>
    </WsDialog>
  );
};

export default CandidateSummaryDialog;
